import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f71a0110"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item-legend-inner" }
const _hoisted_2 = { class: "grid-item-body" }
const _hoisted_3 = ["src"]

type ImagePanelUIProps = {
  url: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    url: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", { src: __props.url }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})